import React, { useState } from "react";
import styled from "styled-components";
import Container from "react-bootstrap/Container";
import { Footer, Header3 } from "../components";

const PrivacyPage = () => {
  const [privicyButton, setprivicyButton] = useState(1);

  return (
    <>
      <Header3 />
      <Wrapper>
        <Container>
          <nav className="hero__nav__wrapper">
            <div className="hero__nav">
              <button
                className={`heading-text ${
                  privicyButton === 1 ? "active" : undefined
                }`}
                onClick={() => setprivicyButton(1)}
              >
                Privacy Policy
              </button>
              <button
                className={`heading-text ${
                  privicyButton === 2 ? "active" : undefined
                }`}
                onClick={() => setprivicyButton(2)}
              >
                Terms of Service
              </button>
              <button
                className={`heading-text ${
                  privicyButton === 3 ? "active" : undefined
                }`}
                onClick={() => setprivicyButton(3)}
              >
                Cancellation Policy
              </button>
            </div>
          </nav>

          <div className="contentWrapper">
            {privicyButton === 1 ? (
              <div className="Content">
                <h6>Effective date: 06/01/2021</h6>
                <h4>1. Introduction</h4>
                <h6>Welcome to Wecanrush.</h6>
                <h6>
                  Wecanrush Inc (“us”, “we”, or “our”) operates
                  https://wecanrush.com(hereinafter referred to as “Service”).
                </h6>
                <h6>
                  Our Privacy Policy governs your visit to
                  https://wecanrush.com, and explains how we collect, safeguard
                  and disclose information that results from your use of our
                  Service.
                </h6>
                <h6>
                  We use your data to provide and improve Service. By using
                  Service, you agree to the collection and use of information in
                  accordance with this policy. Unless otherwise defined in this
                  Privacy Policy, the terms used in this Privacy Policy have the
                  same meanings as in our Terms and Conditions.
                </h6>
                <h6>
                  Our Terms and Conditions (“Terms”) govern all use of our
                  Service and together with the Privacy Policy constitutes your
                  agreement with us (“agreement”).
                </h6>
                <h4>2. Definitions</h4>
                <h6>
                  SERVICE means the https://wecanrush.com website/app operated
                  by Wecanrush Inc.
                </h6>
                <h6>
                  PERSONAL DATA means data about a living individual who can be
                  identified from those data (or from those and other
                  information either in our possession or likely to come into
                  our possession).
                </h6>
                <h6>
                  USAGE DATA is data collected automatically either generated by
                  the use of Service or from Service infrastructure itself (for
                  example, the duration of a page visit).
                </h6>
                <h6>
                  COOKIES are small files stored on your device (computer or
                  mobile device).
                </h6>
                <h6>
                  DATA CONTROLLER means a natural or legal person who (either
                  alone or jointly or in common with other persons) determines
                  the purposes for which and the manner in which any personal
                  data are, or are to be, processed. For the purpose of this
                  Privacy Policy, we are a Data Controller of your data.
                </h6>
                <h6>
                  DATA PROCESSORS (OR SERVICE PROVIDERS) means any natural or
                  legal person who processes the data on behalf of the Data
                  Controller. We may use the services of various Service
                  Providers in order to process your data more effectively.
                </h6>
                <h6>
                  DATA SUBJECT is any living individual who is the subject of
                  Personal Data.
                </h6>
                <h6>
                  THE USER is the individual using our Service. The User
                  corresponds to the Data Subject, who is the subject of
                  Personal Data.
                </h6>
                <h4>3. Information Collection and Use</h4>
                <h6>
                  We collect several different types of information for various
                  purposes to provide and improve our Service to you.
                </h6>
                <h4>4. Types of Data Collected</h4>
                <h6>Personal Data</h6>
                <h6>
                  While using our Service, we may ask you to provide us with
                  certain personally identifiable information that can be used
                  to contact or identify you (“Personal Data”). Personally
                  identifiable information may include, but is not limited to:
                </h6>
                <h6>0.1. Email address</h6>
                <h6>0.2. First name and last name</h6>
                <h6>0.3. Phone number</h6>
                <h6>
                  0.4. Address, Country, State, Province, ZIP/Postal code, City
                </h6>
                <h6>0.5. Cookies and Usage Data</h6>
                <h6>
                  We may use your Personal Data to contact you with newsletters,
                  marketing or promotional materials and other information that
                  may be of interest to you. You may opt out of receiving any,
                  or all, of these communications from us by following the
                  unsubscribe link.
                </h6>
                <h6>Usage Data</h6>
                <h6>
                  We may also collect information that your browser sends
                  whenever you visit our Service or when you access Service by
                  or through any device (“Usage Data”).
                </h6>
                <h6>
                  This Usage Data may include information such as your
                  computer’s Internet Protocol address (e.g. IP address),
                  browser type, browser version, the pages of our Service that
                  you visit, the time and date of your visit, the time spent on
                  those pages, unique device identifiers and other diagnostic
                  data.
                </h6>
                <h6>
                  When you access Service with a device, this Usage Data may
                  include information such as the type of device you use, your
                  device unique ID, the IP address of your device, your device
                  operating system, the type of Internet browser you use, unique
                  device identifiers and other diagnostic data.
                </h6>
                <h6>Location Data</h6>
                <h6>
                  We may use and store information about your location if you
                  give us permission to do so (“Location Data”). We use this
                  data to provide features of our Service, to improve and
                  customize our Service.
                </h6>
                <h6>
                  You can enable or disable location services when you use our
                  Service at any time by way of your device settings.
                </h6>
                <h6>Tracking Cookies Data</h6>
                <h6>
                  We use cookies and similar tracking technologies to track the
                  activity on our Service and we hold certain information.
                </h6>
                <h6>
                  Cookies are files with a small amount of data which may
                  include an anonymous unique identifier. Cookies are sent to
                  your browser from a website and stored on your device. Other
                  tracking technologies are also used such as beacons, tags and
                  scripts to collect and track information and to improve and
                  analyze our Service.
                </h6>
                <h6>
                  You can instruct your browser to refuse all cookies or to
                  indicate when a cookie is being sent. However, if you do not
                  accept cookies, you may not be able to use some portions of
                  our Service.
                </h6>
                <h6>Examples of Cookies we use:</h6>
                <h6>
                  0.1. Session Cookies: We use Session Cookies to operate our
                  Service.
                </h6>
                <h6>
                  0.2. Preference Cookies: We use Preference Cookies to remember
                  your preferences and various settings.
                </h6>
                <h6>
                  0.3. Security Cookies: We use Security Cookies for security
                  purposes.
                </h6>
                <h6>
                  0.4. Advertising Cookies: Advertising Cookies are used to
                  serve you with advertisements that may be relevant to you and
                  your interests.
                </h6>
                <h6>Other Data</h6>
                <h6>
                  While using our Service, we may also collect the following
                  information: sex, age, date of birth, place of birth, passport
                  details, citizenship, registration at place of residence and
                  actual address, telephone number (work, mobile), details of
                  documents on education, qualification, professional training,
                  employment agreements, NDA agreements, information on bonuses
                  and compensation, information on marital status, family
                  members, social security (or other taxpayer identification)
                  number, office location and other data.
                </h6>
                <h4>5. Use of Data</h4>
                <h6>
                  Easypass Ltd uses the collected data for various purposes:
                </h6>
                <h6>0.1. to provide and maintain our Service;</h6>
                <h6>0.2. to notify you about changes to our Service;</h6>
                <h6>
                  0.3. to allow you to participate in interactive features of
                  our Service when you choose to do so;
                </h6>
                <h6>0.4. to provide customer support;</h6>
                <h6>
                  0.5. to gather analysis or valuable information so that we can
                  improve our Service;
                </h6>
                <h6>0.6. to monitor the usage of our Service;</h6>
                <h6>0.7. to detect, prevent and address technical issues;</h6>
                <h6>
                  0.8. to fulfil any other purpose for which you provide it;
                </h6>
                <h6>
                  0.9. to carry out our obligations and enforce our rights
                  arising from any contracts entered into between you and us,
                  including for billing and collection;
                </h6>
                <h6>
                  0.10. to provide you with notices about your account and/or
                  subscription, including expiration and renewal notices,
                  email-instructions, etc.;
                </h6>
                <h6>
                  0.11. to provide you with news, special offers and general
                  information about other goods, services and events which we
                  offer that are similar to those that you have already
                  purchased or enquired about unless you have opted not to
                  receive such information;
                </h6>
                <h6>
                  0.12. in any other way we may describe when you provide the
                  information;
                </h6>
                <h6>0.13. for any other purpose with your consent.</h6>
                <h4>6. Retention of Data</h4>
                <h6>
                  We will retain your Personal Data only for as long as is
                  necessary for the purposes set out in this Privacy Policy. We
                  will retain and use your Personal Data to the extent necessary
                  to comply with our legal obligations (for example, if we are
                  required to retain your data to comply with applicable laws),
                  resolve disputes, and enforce our legal agreements and
                  policies.
                </h6>
                <h6>
                  We will also retain Usage Data for internal analysis purposes.
                  Usage Data is generally retained for a shorter period, except
                  when this data is used to strengthen the security or to
                  improve the functionality of our Service, or we are legally
                  obligated to retain this data for longer time periods.
                </h6>
                <h4>7. Transfer of Data</h4>
                <h6>
                  Your information, including Personal Data, may be transferred
                  to – and maintained on – computers located outside of your
                  state, province, country or other governmental jurisdiction
                  where the data protection laws may differ from those of your
                  jurisdiction.
                </h6>
                <h6>
                  If you are located outside Nigeria and choose to provide
                  information to us, please note that we transfer the data,
                  including Personal Data, to Nigeria and process it there.
                </h6>
                <h6>
                  Your consent to this Privacy Policy followed by your
                  submission of such information represents your agreement to
                  that transfer.
                </h6>
                <h6>
                  Easypass Ltd will take all the steps reasonably necessary to
                  ensure that your data is treated securely and in accordance
                  with this Privacy Policy and no transfer of your Personal Data
                  will take place to an organisation or a country unless there
                  are adequate controls in place including the security of your
                  data and other personal information.
                </h6>
                <h4>8. Disclosure of Data</h4>
                <h6>
                  We may disclose personal information that we collect, or you
                  provide:
                </h6>
                <h6>0.1. Disclosure for Law Enforcement.</h6>
                <h6>
                  Under certain circumstances, we may be required to disclose
                  your Personal Data if required to do so by law or in response
                  to valid requests by public authorities.
                </h6>
                <h6>0.2. Business Transaction.</h6>
                <h6>
                  If we or our subsidiaries are involved in a merger,
                  acquisition or asset sale, your Personal Data may be
                  transferred.
                </h6>
                <h6>
                  0.3. Other cases. We may disclose your information also:
                </h6>
                <h6>0.3.1. to our subsidiaries and affiliates;</h6>
                <h6>
                  0.3.2. to contractors, service providers, and other third
                  parties we use to support our business;
                </h6>
                <h6>0.3.3. to fulfill the purpose for which you provide it;</h6>
                <h6>
                  0.3.4. for the purpose of including your company’s logo on our
                  website;
                </h6>
                <h6>
                  0.3.5. for any other purpose disclosed by us when you provide
                  the information;
                </h6>
                <h6>0.3.6. with your consent in any other cases;</h6>
                <h6>
                  0.3.7. if we believe disclosure is necessary or appropriate to
                  protect the rights, property, or safety of the Company, our
                  customers, or others.
                </h6>
                <h4>9. Security of Data</h4>
                <h6>
                  The security of your data is important to us but remember that
                  no method of transmission over the Internet or method of
                  electronic storage is 100% secure. While we strive to use
                  commercially acceptable means to protect your Personal Data,
                  we cannot guarantee its absolute security.
                </h6>
                <h4>
                  10. Your Data Protection Rights Under General Data Protection
                  Regulation (GDPR)
                </h4>
                <h6>
                  If you are a resident of the European Union (EU) and European
                  Economic Area (EEA), you have certain data protection rights,
                  covered by GDPR.
                </h6>
                <h6>
                  We aim to take reasonable steps to allow you to correct,
                  amend, delete, or limit the use of your Personal Data.
                </h6>
                <h6>
                  If you wish to be informed what Personal Data we hold about
                  you and if you want it to be removed from our systems, please
                  email us at hello@easypass.ng.
                </h6>
                <h6>
                  In certain circumstances, you have the following data
                  protection rights:
                </h6>
                <h6>
                  0.1. the right to access, update or to delete the information
                  we have on you;
                </h6>
                <h6>
                  0.2. the right of rectification. You have the right to have
                  your information rectified if that information is inaccurate
                  or incomplete;
                </h6>
                <h6>
                  0.3. the right to object. You have the right to object to our
                  processing of your Personal Data;
                </h6>
                <h6>
                  0.4. the right of restriction. You have the right to request
                  that we restrict the processing of your personal information;
                </h6>
                <h6>
                  0.5. the right to data portability. You have the right to be
                  provided with a copy of your Personal Data in a structured,
                  machine-readable and commonly used format;
                </h6>
                <h6>
                  0.6. the right to withdraw consent. You also have the right to
                  withdraw your consent at any time where we rely on your
                  consent to process your personal information;
                </h6>
                <h6>
                  Please note that we may ask you to verify your identity before
                  responding to such requests. Please note, we may not able to
                  provide Service without some necessary data.
                </h6>
                <h6>
                  You have the right to complain to a Data Protection Authority
                  about our collection and use of your Personal Data. For more
                  information, please contact your local data protection
                  authority in the European Economic Area (EEA).
                </h6>
                <h4>11. Your Data Protection Rights</h4>
                <h6>
                  CalOPPA is the first state law in the nation to require
                  commercial websites and online services to post a privacy
                  policy. The law’s reach stretches well beyond California to
                  require a person or company in the United States (and
                  conceivable the world) that operates websites collecting
                  personally identifiable information from California consumers
                  to post a conspicuous privacy policy on its website stating
                  exactly the information being collected and those individuals
                  with whom it is being shared, and to comply with this policy.
                </h6>
                <h6>According to CalOPPA we agree to the following:</h6>
                <h6>0.1. users can visit our site anonymously;</h6>
                <h6>
                  0.2. our Privacy Policy link includes the word “Privacy”, and
                  can easily be found on the home page of our website;
                </h6>
                <h6>
                  0.3. users will be notified of any privacy policy changes on
                  our Privacy Policy Page;
                </h6>
                <h6>
                  0.4. users are able to change their personal information by
                  emailing us at hello@easypass.ng.
                </h6>
                <h6>Our Policy on “Do Not Track” Signals:</h6>
                <h6>
                  We honor Do Not Track signals and do not track, plant cookies,
                  or use advertising when a Do Not Track browser mechanism is in
                  place. Do Not Track is a preference you can set in your web
                  browser to inform websites that you do not want to be tracked.
                </h6>
                <h6>
                  You can enable or disable Do Not Track by visiting the
                  Preferences or Settings page of your web browser.
                </h6>
                <h6>12. Your Data Protection Rights</h6>
                <h6>
                  0.1. What personal information we have about you. If you make
                  this request, we will return to you:
                </h6>
                <h6>
                  0.0.1. The categories of personal information we have
                  collected about you.
                </h6>
                <h6>
                  0.0.2. The categories of sources from which we collect your
                  personal information.
                </h6>
                <h6>
                  0.0.3. The business or commercial purpose for collecting or
                  selling your personal information.
                </h6>
                <h6>
                  0.0.4. The categories of third parties with whom we share
                  personal information.
                </h6>
                <h6>
                  0.0.5. The specific pieces of personal information we have
                  collected about you.
                </h6>
                <h6>
                  0.0.6. A list of categories of personal information that we
                  have sold, along with the category of any other company we
                  sold it to. If we have not sold your personal information, we
                  will inform you of that fact.
                </h6>
                <h6>
                  0.0.7. A list of categories of personal information that we
                  have disclosed for a business purpose, along with the category
                  of any other company we shared it with.
                </h6>
                <h6>
                  Please note, you are entitled to ask us to provide you with
                  this information up to two times in a rolling twelve-month
                  period. When you make this request, the information provided
                  may be limited to the personal information we collected about
                  you in the previous 12 months.
                </h6>
                <h6>
                  0.2. To delete your personal information. If you make this
                  request, we will delete the personal information we hold about
                  you as of the date of your request from our records and direct
                  any service providers to do the same. In some cases, deletion
                  may be accomplished through de-identification of the
                  information. If you choose to delete your personal
                  information, you may not be able to use certain functions that
                  require your personal information to operate.
                </h6>
                <h6>
                  0.3. To stop selling your personal information. We don’t sell
                  or rent your personal information to any third parties for any
                  purpose. We do not sell your personal information for monetary
                  consideration. However, under some circumstances, a transfer
                  of personal information to a third party, or within our family
                  of companies, without monetary consideration may be considered
                  a “sale” under California law. You are the only owner of your
                  Personal Data and can request disclosure or deletion at any
                  time.
                </h6>
                <h6>
                  If you submit a request to stop selling your personal
                  information, we will stop making such transfers.
                </h6>
                <h6>
                  Please note, if you ask us to delete or stop selling your
                  data, it may impact your experience with us, and you may not
                  be able to participate in certain programs or membership
                  services which require the usage of your personal information
                  to function. But in no circumstances, we will discriminate
                  against you for exercising your rights.
                </h6>
                <h6>
                  To exercise your California data protection rights described
                  above, please send your request(s) by email:
                  hello@easypass.ng.
                </h6>
                <h6>
                  Your data protection rights, described above, are covered by
                  the CCPA, short for the California Consumer Privacy Act. To
                  find out more, visit the official California Legislative
                  Information website. The CCPA took effect on 01/01/2020.
                </h6>
                <h4>13. Service Providers</h4>
                <h6>
                  We may employ third party companies and individuals to
                  facilitate our Service (“Service Providers”), provide Service
                  on our behalf, perform Service-related services or assist us
                  in analysing how our Service is used.
                </h6>
                <h6>
                  These third parties have access to your Personal Data only to
                  perform these tasks on our behalf and are obligated not to
                  disclose or use it for any other purpose.
                </h6>
                <h4>14. Analytics</h4>
                <h6>
                  We may use third-party Service Providers to monitor and
                  analyze the use of our Service.
                </h6>
                <h4>15. CI/CD tools</h4>
                <h6>
                  We may use third-party Service Providers to automate the
                  development process of our Service.
                </h6>
                <h4>16. Advertising</h4>
                <h6>
                  We may use third-party Service Providers to show
                  advertisements to you to help support and maintain our
                  Service.
                </h6>
                <h4>17. Behavioral Remarketing </h4>
                <h6>
                  We may use remarketing services to advertise on third party
                  websites to you after you visited our Service. We and our
                  third-party vendors use cookies to inform, optimise and serve
                  ads based on your past visits to our Service.
                </h6>
                <h4>18. Payments</h4>
                <h6>
                  We may provide paid products and/or services within Service.
                  In that case, we use third-party services for payment
                  processing (e.g. payment processors).
                </h6>
                <h6>
                  We will not store or collect your payment card details. That
                  information is provided directly to our third-party payment
                  processors whose use of your personal information is governed
                  by their Privacy Policy. These payment processors adhere to
                  the standards set by PCI-DSS as managed by the PCI Security
                  Standards Council, which is a joint effort of brands like
                  Visa, Mastercard, American Express and Discover. PCI-DSS
                  requirements help ensure the secure handling of payment
                  information.
                </h6>
                <h4>19. Links to Other Sites</h4>
                <h6>
                  Our Service may contain links to other sites that are not
                  operated by us. If you click a third party link, you will be
                  directed to that third party’s site. We strongly advise you to
                  review the Privacy Policy of every site you visit.
                </h6>
                <h6>
                  We have no control over and assume no responsibility for the
                  content, privacy policies or practices of any third party
                  sites or services.
                </h6>
                <h6>
                  For example, the outlined privacy policy has been made using
                  PolicyMaker.io, a free tool that helps create high-quality
                  legal documents. PolicyMaker’s privacy policy generator is an
                  easy-to-use tool for creating a privacy policy for blog,
                  website, e-commerce store or mobile app.
                </h6>
                <h4>20. Children’s Privacy</h4>
                <h6>
                  Our Services are not intended for use by children under the
                  age of 18 (“Child” or “Children”).
                </h6>
                <h6>
                  We do not knowingly collect personally identifiable
                  information from Children under 18. If you become aware that a
                  Child has provided us with Personal Data, please contact us.
                  If we become aware that we have collected Personal Data from
                  Children without verification of parental consent, we take
                  steps to remove that information from our servers.
                </h6>
                <h4>21. Changes to This Privacy Policy</h4>
                <h6>
                  We may update our Privacy Policy from time to time. We will
                  notify you of any changes by posting the new Privacy Policy on
                  this page.
                </h6>
                <h6>
                  We will let you know via email and/or a prominent notice on
                  our Service, prior to the change becoming effective and update
                  “effective date” at the top of this Privacy Policy.
                </h6>
                <h6>
                  You are advised to review this Privacy Policy periodically for
                  any changes. Changes to this Privacy Policy are effective when
                  they are posted on this page.
                </h6>
                <h6>22. Contact Us</h6>
                <h6>
                  If you have any questions about this Privacy Policy, please
                  contact us by email: info@wecanrush.com.
                </h6>
              </div>
            ) : undefined}
          </div>

          <div className="contentWrapper">
            {privicyButton === 2 ? (
              <div className="Content">
                <h6>Last updated: 06/01/2021</h6>
                <h4> ⦁ Introduction </h4>
                <h6>
                  Welcome to WeCanRush Inc (AKA Rush) (“Company”, “we”, “our”,
                  “us”)! As you have just clicked our Terms of Service, please
                  pause, grab a cup of coffee and carefully read the following
                  pages. It will take you approximately 20 minutes.
                </h6>
                <h6>
                  These Terms of Service (“Terms”, “Terms of Service”) govern
                  your use of our web pages located at
                  https://www.wecanrush.com/ and our mobile
                  application WeCanRush (together or individually
                  “Service”) operated by WeCanRush Inc (AKA Rush)
                </h6>
                <h6>
                  Your agreement with us includes these Terms (“Agreements”).
                  You acknowledge that you have read and understood Agreements,
                  and agree to be bound of them.
                </h6>
                <h6>
                  If you do not agree with (or cannot comply with) Agreements,
                  then you may not use the Service, but please let us know by
                  emailing at info@wecanrush.com so we can try to find a
                  solution. These Terms apply to all visitors, users and others
                  who wish to access or use Service.
                </h6>
                <h6> Thank you for being responsible. </h6>
                <h4>⦁ Communications</h4>
                <h6>
                  By creating an Account on our Service, you agree to subscribe
                  to newsletters, marketing or promotional materials and other
                  information we may send. However, you may opt out of receiving
                  any, or all, of these communications from us by following the
                  unsubscribe link or by emailing at.
                </h6>
                <h4> ⦁ Purchases</h4>
                <h6>
                  If you wish to purchase any product or service made available
                  through Service (“Purchase”), you may be asked to supply
                  certain information relevant to your Purchase including,
                  without limitation, your credit card number, the expiration
                  date of your credit card, your billing address, and your
                  shipping information.
                </h6>
                <h6>
                  You represent and warrant that: (i) you have the legal right
                  to use any credit card(s) or other payment method(s) in
                  connection with any Purchase; and that (ii) the information
                  you supply to us is true, correct and complete.
                </h6>
                <h6>
                  We may employ the use of third party services for the purpose
                  of facilitating payment and the completion of Purchases. By
                  submitting your information, you grant us the right to provide
                  the information to these third parties.
                </h6>
                <h6>
                  We reserve the right to refuse or cancel your order at any
                  time for reasons including but not limited to: product or
                  service availability, errors in the description or price of
                  the product or service, error in your order or other reasons.
                </h6>
                <h6>
                  We reserve the right to refuse or cancel your order if fraud
                  or an unauthorized or illegal transaction is suspected.
                </h6>
                <h4> ⦁ Contests, Sweepstakes and Promotions</h4>
                <h6>
                  Any contests, sweepstakes or other promotions (collectively,
                  “Promotions”) made available through Service may be governed
                  by rules that are separate from these Terms of Service. If you
                  participate in any Promotions, please review the applicable
                  rules. If the rules for a Promotion conflict with these Terms
                  of Service, Promotion rules will apply.
                </h6>
                <h4> ⦁ Fee Changes </h4>
                <h6>
                  {" "}
                  WeCanRush Inc (AKA Rush), in its sole discretion and at any
                  time, may modify Subscription fees for the Subscriptions. Any
                  Subscription fee change will become effective at the end of
                  the then-current Billing Cycle.{" "}
                </h6>
                <h6>
                  WeCanRush Inc (AKA Rush) will provide you with a reasonable
                  prior notice of any change in Subscription fees to give you an
                  opportunity to terminate your Subscription before such change
                  becomes effective.
                </h6>
                <h6>
                  Your continued use of Service after Subscription fee change
                  comes into effect constitutes your agreement to pay the
                  modified Subscription fee amount.
                </h6>
                <h4> ⦁ Refunds</h4>
                <h6>
                  We issue refunds for Contracts within twenty-one (21) days of
                  the original purchase of the Contract.
                </h6>
                <h4>⦁ Content</h4>
                Our Service allows you to post, link, store, share and otherwise
                make available certain information, text, graphics, videos, or
                other material (“Content”). You are responsible for Content that
                you post on or through Service, including its legality,
                reliability, and appropriateness.
                <h6>
                  By posting Content on or through Service, You represent and
                  warrant that: (i) Content is yours (you own it) and/or you
                  have the right to use it and the right to grant us the rights
                  and license as provided in these Terms, and (ii) that the
                  posting of your Content on or through Service does not violate
                  the privacy rights, publicity rights, copyrights, contract
                  rights or any other rights of any person or entity. We reserve
                  the right to terminate the account of anyone found to be
                  infringing on a copyright.
                </h6>
                <h6>
                  You retain any and all of your rights to any Content you
                  submit, post or display on or through Service and you are
                  responsible for protecting those rights. We take no
                  responsibility and assume no liability for Content you or any
                  third party posts on or through Service. However, by posting
                  Content using Service you grant us the right and license to
                  use, modify, publicly perform, publicly display, reproduce,
                  and distribute such Content on and through Service. You agree
                  that this license includes the right for us to make your
                  Content available to other users of Service, who may also use
                  your Content subject to these Terms.
                </h6>
                <h6>
                  WeCanRush Inc (AKA Rush) has the right but not the obligation
                  to monitor and edit all Content provided by users.
                </h6>
                <h6>
                  In addition, Content found on or through this Service are the
                  property of WeCanRush Inc (AKA Rush) or used with permission.
                  You may not distribute, modify, transmit, reuse, download,
                  repost, copy, or use said Content, whether in whole or in
                  part, for commercial purposes or for personal gain, without
                  express advance written permission from us.
                </h6>
                <h4>⦁ Prohibited Uses</h4>
                <h6>
                  You may use Service only for lawful purposes and in accordance
                  with Terms. You agree not to use Service:
                </h6>
                <h6>
                  ⦁ In any way that violates any applicable national or
                  international law or regulation.
                </h6>
                <h6>
                  ⦁ For the purpose of exploiting, harming, or attempting to
                  exploit or harm minors in any way by exposing them to
                  inappropriate content or otherwise.
                </h6>
                <h6></h6>
                <h6>
                  ⦁ To transmit, or procure the sending of, any advertising or
                  promotional material, including any “junk mail”, “chain
                  letter,” “spam,” or any other similar solicitation.
                </h6>
                <h6>
                  ⦁ To impersonate or attempt to impersonate Company, a Company
                  employee, another user, or any other person or entity.
                </h6>
                <h6>
                  ⦁ In any way that infringes upon the rights of others, or in
                  any way is illegal, threatening, fraudulent, or harmful, or in
                  connection with any unlawful, illegal, fraudulent, or harmful
                  purpose or activity.
                </h6>
                <h6>
                  ⦁ To engage in any other conduct that restricts or inhibits
                  anyone’s use or enjoyment of Service, or which, as determined
                  by us, may harm or offend Company or users of Service or
                  expose them to liability.
                </h6>
                <h4>Additionally, you agree not to: </h4>
                <h6>
                  ⦁ Use Service in any manner that could disable, overburden,
                  damage, or impair Service or interfere with any other party’s
                  use of Service, including their ability to engage in real time
                  activities through Service.
                </h6>
                <h6>
                  ⦁ Use any robot, spider, or other automatic device, process,
                  or means to access Service for any purpose, including
                  monitoring or copying any of the material on Service.
                </h6>
                <h6>
                  ⦁ Use any manual process to monitor or copy any of the
                  material on Service or for any other unauthorized purpose
                  without our prior written consent.
                </h6>
                <h6>
                  ⦁ Use any device, software, or routine that interferes with
                  the proper working of Service.
                </h6>
                <h6>
                  ⦁ Introduce any viruses, trojan horses, worms, logic bombs, or
                  other material which is malicious or
                </h6>
                <h6>
                  ⦁ Attempt to gain unauthorized access to, interfere with,
                  damage, or disrupt any parts of Service, the server on which
                  Service is stored, or any server, computer, or database
                  connected to Service.{" "}
                </h6>
                <h6>
                  ⦁ Attack Service via a denial-of-service attack or a
                  distributed denial-of-service attack.
                </h6>
                <h6>
                  ⦁ Take any action that may damage or falsify Company rating.
                </h6>
                <h6>
                  ⦁ Otherwise attempt to interfere with the proper working of
                  Service.
                </h6>
                <h4>⦁ Analytics</h4>
                <h6>
                  We may use third-party Service Providers to monitor and
                  analyze the use of our Service.
                </h6>
                <h4>Google Analytics </h4>
                <h6>
                  Google Analytics is a web analytics service offered by Google
                  that tracks and reports website traffic. Google uses the data
                  collected to track and monitor the use of our Service.
                </h6>
                <h6>
                  This data is shared with other Google services. Google may use
                  the collected data to contextualise and personalise the ads of
                  its own advertising network.
                </h6>
                <h6>
                  For more information on the privacy practices of Google,
                  please visit the Google Privacy Terms web page:
                  https://policies.google.com/privacy?hl=en
                </h6>
                <h6>
                  We also encourage you to review the Google's policy for
                  safeguarding your data:
                  https://support.google.com/analytics/answer/6004245.
                </h6>
                <h6>
                  Cloudflare analytics Cloudflare analytics is a web analytics
                  service operated by Cloudflare Inc. Read the Privacy Policy
                  here: https://www.cloudflare.com/privacypolicy/
                </h6>
                <h4> ⦁ No Use By Minors</h4>
                <h6>
                  Service is intended only for access and use by individuals at
                  least eighteen (18) years old. By accessing or using any of
                  Company, you warrant and represent that you are at least
                  eighteen (18) years of age and with the full authority, right,
                  and capacity to enter into this agreement and abide by all of
                  the terms and conditions of Terms. If you are not at least
                  eighteen (18) years old, you are prohibited from both the
                  access and usage of Service.
                </h6>
                <h4>⦁ Accounts</h4>
                <h6>
                  When you create an account with us, you guarantee that you are
                  above the age of 18, and that the information you provide us
                  is accurate, complete, and current at all times. Inaccurate,
                  incomplete, or obsolete information may result in the
                  immediate termination of your account on Service.
                </h6>
                <h6>
                  You are responsible for maintaining the confidentiality of
                  your account and password, including but not limited to the
                  restriction of access to your computer and/or account. You
                  agree to accept responsibility for any and all activities or
                  actions that occur under your account and/or password, whether
                  your password is with our Service or a third-party service.
                  You must notify us immediately upon becoming aware of any
                  breach of security or unauthorized use of your account.
                </h6>
                <h6>
                  You may not use as a username the name of another person or
                  entity or that is not lawfully available for use, a name or
                  trademark that is subject to any rights of another person or
                  entity other than you, without appropriate authorization. You
                  may not use as a username any name that is offensive, vulgar
                  or obscene.
                </h6>
                <h6>
                  We reserve the right to refuse service, terminate accounts,
                  remove or edit content, or cancel orders in our sole
                  discretion.
                </h6>
                <h4>⦁ Intellectual Property</h4>
                <h6>
                  Service and its original content (excluding Content provided
                  by users), features and functionality are and will remain the
                  exclusive property of WeCanRush Inc (AKA Rush) and its
                  licensors. Service is protected by copyright, trademark, and
                  other laws of the United States. Our trademarks and trade
                  dress may not be used in connection with any product or
                  service without the prior written consent of WeCanRush Inc
                  (AKA Rush).
                </h6>
                <h4>⦁ Copyright Policy</h4>
                <h6>
                  We respect the intellectual property rights of others. It is
                  our policy to respond to any claim that Content posted on
                  Service infringes on the copyright or other intellectual
                  property rights <h4>(“Infringement”)</h4> of any person or
                  entity.{" "}
                </h6>
                <h6>
                  If you are a copyright owner, or authorized on behalf of one,
                  and you believe that the copyrighted work has been copied in a
                  way that constitutes copyright infringement, please submit
                  your claim via email to info@wecanrush.com, with the subject
                  line: “Copyright Infringement” and include in your claim a
                  detailed description of the alleged Infringement as detailed
                  below, under “DMCA Notice and Procedure for Copyright
                  Infringement Claims”
                </h6>
                <h6>
                  You may be held accountable for damages (including costs and
                  attorneys' fees) for misrepresentation or bad-faith claims on
                  the infringement of any Content found on and/or through
                  Service on your copyright.
                </h6>
                <h4>
                  ⦁ DMCA Notice and Procedure for Copyright Infringement Claims
                </h4>
                <h6>
                  You may submit a notification pursuant to the Digital
                  Millennium Copyright Act (DMCA) by providing our Copyright
                  Agent with the following information in writing (see 17 U.S.C
                  512(c)(3) for further detail):
                </h6>
                <h6>
                  ⦁ an electronic or physical signature of the person authorized
                  to act on behalf of the owner of the copyright's interest;
                </h6>
                <h6>
                  ⦁ a description of the copyrighted work that you claim has
                  been infringed, including the URL (i.e., web page address) of
                  the location where the copyrighted work exists or a copy of
                  the copyrighted work;
                </h6>
                <h6>
                  ⦁ identification of the URL or other specific location on
                  Service where the material that you claim is infringing is
                  located;
                </h6>
                <h6>⦁ your address, telephone number, and email address;</h6>
                <h6>
                  ⦁ a statement by you that you have a good faith belief that
                  the disputed use is not authorized by the copyright owner, its
                  agent, or the law;{" "}
                </h6>
                <h6>
                  ⦁ a statement by you, made under penalty of perjury, that the
                  above information in your notice is accurate and that you are
                  the copyright owner or authorized to act on the copyright
                  owner's behalf.
                </h6>
                <h6>
                  You can contact our Copyright Agent via email
                  at info@wecanrush.com
                </h6>
                <h4> ⦁ Error Reporting and Feedback</h4>
                <h6>
                  You may provide us either directly at info@wecanrush.com or
                  via third party sites and tools with information and feedback
                  concerning errors, suggestions for improvements, ideas,
                  problems, complaints, and other matters related to our Service
                  (“Feedback”). You acknowledge and agree that: (i) you shall
                  not retain, acquire or assert any intellectual property right
                  or other right, title or interest in or to the Feedback; (ii)
                  Company may have development ideas similar to the Feedback;
                  (iii) Feedback does not contain confidential information or
                  proprietary information from you or any third party; and (iv)
                  Company is not under any obligation of confidentiality with
                  respect to the Feedback. In the event the transfer of the
                  ownership to the Feedback is not possible due to applicable
                  mandatory laws, you grant Company and its affiliates an
                  exclusive, transferable, irrevocable, free-of-charge,
                  sub-licensable, unlimited and perpetual right to use
                  (including copy, modify, create derivative works, publish,
                  distribute and commercialize) Feedback in any manner and for
                  any purpose.
                </h6>
                <h6>
                  The third party sites and tools mentioned above include the
                  following:
                </h6>
                <h4>Bugsnag</h4>
                <h6>
                  Bugsnag is a platform for monitoring and logging stability of
                  applications provided by Bugsnag Inc. Please read their
                  Privacy Policy here:
                  https://docs.bugsnag.com/legal/privacy-policy/
                </h6>
                <h4>Sentry</h4>
                <h6>
                  Sentry is open-source error tracking solution provided by
                  Functional Software Inc. More information is available here:
                  https://sentry.io/privacy/
                </h6>
                <h4> Firebase Crashlytics</h4>
                <h6>
                  Firebase Crashlytics is bug reporting service provided by
                  Google Inc.
                </h6>
                <h6>
                  You may opt-out of certain Firebase features through your
                  mobile device settings, such as your device advertising
                  settings or by following the instructions provided by Google
                  in their Privacy Policy:
                  https://policies.google.com/privacy?hl=en
                </h6>
                <h6>
                  For more information on what type of information Firebase
                  collects, please visit the Google Privacy Terms web page:
                  https://policies.google.com/privacy?hl=en
                </h6>
                <h4> ⦁ Links To Other Web Sites</h4>
                <h6>
                  Our Service may contain links to third party web sites or
                  services that are not owned or controlled by WeCanRush Inc
                  (AKA Rush)
                </h6>
                <h6>
                  WeCanRush Inc (AKA Rush) has no control over, and assumes no
                  responsibility for the content, privacy policies, or practices
                  of any third party web sites or services. We do not warrant
                  the offerings of any of these entities/individuals or their
                  websites.{" "}
                </h6>
                <h6>
                  YOU ACKNOWLEDGE AND AGREE THAT WeCanRush Inc (AKA Rush) SHALL
                  NOT BE RESPONSIBLE OR LIABLE, DIRECTLY OR INDIRECTLY, FOR ANY
                  DAMAGE OR LOSS CAUSED OR ALLEGED TO BE CAUSED BY OR IN
                  CONNECTION WITH USE OF OR RELIANCE ON ANY SUCH CONTENT, GOODS
                  OR SERVICES AVAILABLE ON OR THROUGH ANY SUCH THIRD PARTY WEB
                  SITES OR SERVICES.
                </h6>
                <h6>
                  WE STRONGLY ADVISE YOU TO READ THE TERMS OF SERVICE AND
                  PRIVACY POLICIES OF ANY THIRD PARTY WEB SITES OR SERVICES THAT
                  YOU VISIT.
                </h6>
                <h4> ⦁ Disclaimer Of Warranty </h4>
                <h6>
                  THESE SERVICES ARE PROVIDED BY COMPANY ON AN “AS IS” AND “AS
                  AVAILABLE” BASIS. COMPANY MAKES NO REPRESENTATIONS OR
                  WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE
                  OPERATION OF THEIR SERVICES, OR THE INFORMATION, CONTENT OR
                  MATERIALS INCLUDED THEREIN. YOU EXPRESSLY AGREE THAT YOUR USE
                  OF THESE SERVICES, THEIR CONTENT, AND ANY SERVICES OR ITEMS
                  OBTAINED FROM US IS AT YOUR SOLE RISK.{" "}
                </h6>
                <h6>
                  NEITHER COMPANY NOR ANY PERSON ASSOCIATED WITH COMPANY MAKES
                  ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE
                  COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY, OR
                  AVAILABILITY OF THE SERVICES. WITHOUT LIMITING THE FOREGOING,
                  NEITHER COMPANY NOR ANYONE ASSOCIATED WITH COMPANY REPRESENTS
                  OR WARRANTS THAT THE SERVICES, THEIR CONTENT, OR ANY SERVICES
                  OR ITEMS OBTAINED THROUGH THE SERVICES WILL BE ACCURATE,
                  RELIABLE, ERROR-FREE, OR UNINTERRUPTED, THAT DEFECTS WILL BE
                  CORRECTED, THAT THE SERVICES OR THE SERVER THAT MAKES IT
                  AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS OR
                  THAT THE SERVICES OR ANY SERVICES OR ITEMS OBTAINED THROUGH
                  THE SERVICES WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.{" "}
                </h6>
                <h6>
                  COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER
                  EXPRESS OR IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING BUT NOT
                  LIMITED TO ANY WARRANTIES OF MERCHANTABILITY,
                  NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR PURPOSE.{" "}
                </h6>
                <h6>
                  THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE
                  EXCLUDED OR LIMITED UNDER APPLICABLE LAW.{" "}
                </h6>
                <h4> ⦁ Limitation Of Liability</h4>
                <h6>
                  EXCEPT AS PROHIBITED BY LAW, YOU WILL HOLD US AND OUR
                  OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS HARMLESS FOR ANY
                  INDIRECT, PUNITIVE, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL
                  DAMAGE, HOWEVER IT ARISES (INCLUDING ATTORNEYS' FEES AND ALL
                  RELATED COSTS AND EXPENSES OF LITIGATION AND ARBITRATION, OR
                  AT TRIAL OR ON APPEAL, IF ANY, WHETHER OR NOT LITIGATION OR
                  ARBITRATION IS INSTITUTED), WHETHER IN AN ACTION OF CONTRACT,
                  NEGLIGENCE, OR OTHER TORTIOUS ACTION, OR ARISING OUT OF OR IN
                  CONNECTION WITH THIS AGREEMENT, INCLUDING WITHOUT LIMITATION
                  ANY CLAIM FOR PERSONAL INJURY OR PROPERTY DAMAGE, ARISING FROM
                  THIS AGREEMENT AND ANY VIOLATION BY YOU OF ANY FEDERAL, STATE,
                  OR LOCAL LAWS, STATUTES, RULES, OR REGULATIONS, EVEN IF
                  COMPANY HAS BEEN PREVIOUSLY ADVISED OF THE POSSIBILITY OF SUCH
                  DAMAGE. EXCEPT AS PROHIBITED BY LAW, IF THERE IS LIABILITY
                  FOUND ON THE PART OF COMPANY, IT WILL BE LIMITED TO THE AMOUNT
                  PAID FOR THE PRODUCTS AND/OR SERVICES, AND UNDER NO
                  CIRCUMSTANCES WILL THERE BE CONSEQUENTIAL OR PUNITIVE DAMAGES.
                  SOME STATES DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
                  PUNITIVE, INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE PRIOR
                  LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU.
                </h6>
                <h4> ⦁ Termination</h4>
                <h6>
                  We may terminate or suspend your account and bar access to
                  Service immediately, without prior notice or liability, under
                  our sole discretion, for any reason whatsoever and without
                  limitation, including but not limited to a breach of Terms.
                </h6>
                <h6>
                  If you wish to terminate your account, you may simply
                  discontinue using Service.
                </h6>
                <h6>
                  All provisions of Terms which by their nature should survive
                  termination shall survive termination, including, without
                  limitation, ownership provisions, warranty disclaimers,
                  indemnity and limitations of liability.
                </h6>
                <h4> ⦁ Governing Law</h4>
                <h6>
                  These Terms shall be governed and construed in accordance with
                  the laws of State of Delaware without regard to its conflict
                  of law provisions.
                </h6>
                <h6>
                  Our failure to enforce any right or provision of these Terms
                  will not be considered a waiver of those rights. If any
                  provision of these Terms is held to be invalid or
                  unenforceable by a court, the remaining provisions of these
                  Terms will remain in effect. These Terms constitute the entire
                  agreement between us regarding our Service and supersede and
                  replace any prior agreements we might have had between us
                  regarding Service.{" "}
                </h6>
                <h4>⦁ Changes To Service</h4>
                <h6>
                  We reserve the right to withdraw or amend our Service, and any
                  service or material we provide via Service, in our sole
                  discretion without notice. We will not be liable if for any
                  reason all or any part of Service is unavailable at any time
                  or for any period. From time to time, we may restrict access
                  to some parts of Service, or the entire Service, to users,
                  including registered users.
                </h6>
                <h4>⦁ Amendments To Terms</h4>
                <h6>
                  We may amend Terms at any time by posting the amended terms on
                  this site. It is your responsibility to review these Terms
                  periodically. Your continued use of the Platform following the
                  posting of revised Terms means that you accept and agree to
                  the changes. You are expected to check this page frequently so
                  you are aware of any changes, as they are binding on you. By
                  continuing to access or use our Service after any revisions
                  become effective, you agree to be bound by the revised terms.
                  If you do not agree to the new terms, you are no longer
                  authorized to use Service.
                </h6>
                <h4> ⦁ Waiver And Severability</h4>
                <h6>
                  No waiver by Company of any term or condition set forth in
                  Terms shall be deemed a further or continuing waiver of such
                  term or condition or a waiver of any other term or condition,
                  and any failure of Company to assert a right or provision
                  under Terms shall not constitute a waiver of such right or
                  provision. If any provision of Terms is held by a court or
                  other tribunal of competent jurisdiction to be invalid,
                  illegal or unenforceable for any reason, such provision shall
                  be eliminated or limited to the minimum extent such that the
                  remaining provisions of Terms will continue in full force and
                  effect.{" "}
                </h6>
                <h4> ⦁ Acknowledgement</h4>
                <h6>
                  BY USING SERVICE OR OTHER SERVICES PROVIDED BY US, YOU
                  ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS OF SERVICE AND
                  AGREE TO BE BOUND BY THEM.{" "}
                </h6>
                <h4> ⦁ Contact Us</h4>
                <h6>
                  Please send your feedback, comments, requests for technical
                  support: By visiting this page on our website:
                  https://www.wecanrush.com/contact.
                </h6>
              </div>
            ) : undefined}
          </div>

          <div className="contentWrapper">
            {privicyButton === 3 ? <div className="Content"></div> : undefined}
          </div>
        </Container>
        <Footer />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  .heading-text.active {
    border-bottom: 4px solid #2c5282;
  }

  button.heading-text {
    font-family: Gilroy;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 18px;
    color: #2c5282;
    outline: none;
    border: none;
    padding: 16px;
    margin: 7px;
    background: transparent;
  }

  .hero__nav__wrapper {
    padding: 208px 0 0 0;

    .hero__nav {
      border-bottom: 1px solid #e6e8f1;
      padding: 20px 0;
      .nav_item {
        font-family: Gilroy-Medium;
        font-size: 15px;
        line-height: 18px;
        color: #545777;
        padding: 20px;
        cursor: pointer;
      }
      .nav_item_active {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 15px;
        line-height: 18px;
        color: #2c5282;
        padding: 20px;
        border-bottom: 3px solid #2c5282;
      }
    }
  }
  .contentWrapper {
    padding: 40px 15px;
    h4 {
      color: #455880;
      margin: 0;
    }
    h6 {
      padding: 10px 0;
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 25px;
      color: #455880;
      margin: 0;
    }
  }

  .Content {
    margin-bottom: 30px;
  }
`;

export default PrivacyPage;
